import { authenticatedFastApiAxiosInstanceAllowEmptyString } from "@/lib/data/http";
import { baseFastApiMatterRoute } from "@/lib/data/requests/matters/matter";
import {
  type APIResponse,
  type MatterSettlementDemandPackageSegment,
} from "@/lib/types";

const settlementDemandPackageSegmentsRoute = `${baseFastApiMatterRoute}/settlement-demands/package-segments`;

export const createMatterSettlementDemandPackageSegmentV1 = (
  data: Pick<
    MatterSettlementDemandPackageSegment,
    "matterId" | "settlementDemandId"
  > &
    Partial<MatterSettlementDemandPackageSegment>,
) => {
  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .post<
      APIResponse<MatterSettlementDemandPackageSegment>
    >(settlementDemandPackageSegmentsRoute, data)
    .then((res) => res.data);
};

type UpdateDemandPackageSegmentsPayload = Pick<
  MatterSettlementDemandPackageSegment,
  "matterId"
> & {
  settlementDemandPackageSegments: Array<
    Pick<MatterSettlementDemandPackageSegment, "id" | "dateModified"> & {
      order?: MatterSettlementDemandPackageSegment["order"];
    }
  >;
};

export const updateMatterSettlementDemandPackageSegmentV1 = (
  data: UpdateDemandPackageSegmentsPayload,
) => {
  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .patch<
      APIResponse<MatterSettlementDemandPackageSegment>
    >(settlementDemandPackageSegmentsRoute, data)
    .then((res) => res.data);
};

export const deleteMatterSettlementDemandPackageSegmentV1 = (
  data: Pick<MatterSettlementDemandPackageSegment, "id" | "matterId">,
) => {
  const { id } = data;
  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .delete<
      APIResponse<MatterSettlementDemandPackageSegment>
    >(`${baseFastApiMatterRoute}/settlement-demands/package-segments/${id}`)
    .then((res) => res.data);
};
